"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.find.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _CloseOutlined = _interopRequireDefault(require("@ant-design/icons/CloseOutlined"));

var _MenuOutlined = _interopRequireDefault(require("@ant-design/icons/MenuOutlined"));

var _SearchOutlined = _interopRequireDefault(require("@ant-design/icons/SearchOutlined"));

var _Logo = _interopRequireDefault(require("../../newMenu/Logo"));

var _link = _interopRequireDefault(require("@meepshop/link"));

var _cartPreviewer = _interopRequireDefault(require("@store/cart-previewer"));

var _DecoratorsRoot = require("../../layout/DecoratorsRoot");

var _CartCount = _interopRequireDefault(require("../../menu/CartCount"));

var _constant = require("../constant");

var _utils = require("../../nav/utils");

var _Icon = _interopRequireDefault(require("../../menu/Icon"));

var _useButtonSettings2 = _interopRequireDefault(require("../../hooks/useButtonSettings"));

var _menu = require("../../constants/menu");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("../styles/header.less");

var styles = {
  "root": "meepshop-meep-ui__mobileLayout-header__root",
  "logo": "meepshop-meep-ui__mobileLayout-header__logo",
  "center": "meepshop-meep-ui__mobileLayout-header__center",
  "left": "meepshop-meep-ui__mobileLayout-header__left",
  "right": "meepshop-meep-ui__mobileLayout-header__right",
  "button": "meepshop-meep-ui__mobileLayout-header__button"
};

var ActionButton = function ActionButton(_ref) {
  var _page$pages;

  var page = _ref.page,
      onMemberClick = _ref.onMemberClick;

  var _useContext = (0, _react.useContext)(_DecoratorsRoot.EnhancerContext),
      user = _useContext.user,
      isLogin = _useContext.isLogin;

  var iconProps = (0, _utils.getIconProps)(page, {
    isLogin: isLogin
  });

  var _useButtonSettings = (0, _useButtonSettings2["default"])(page),
      url = _useButtonSettings.url,
      action = _useButtonSettings.action,
      target = _useButtonSettings.target;

  var iconSize = 20;

  if (page.action === _menu.MENU_ACTION_TYPES.CART) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: styles.button
    }, /*#__PURE__*/_react["default"].createElement(_CartCount["default"], {
      showCartCount: true
    }, /*#__PURE__*/_react["default"].createElement(_cartPreviewer["default"], {
      viewer: user
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, iconProps, {
      style: {
        fontSize: iconSize
      }
    })))));
  }

  if (page.action === _menu.MENU_ACTION_TYPES.AUTH && page !== null && page !== void 0 && (_page$pages = page.pages) !== null && _page$pages !== void 0 && _page$pages.length) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      onClick: function onClick() {
        return onMemberClick === null || onMemberClick === void 0 ? void 0 : onMemberClick(page.pages);
      }
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, iconProps, {
      style: {
        fontSize: iconSize
      }
    })));
  }

  if (url) {
    return /*#__PURE__*/_react["default"].createElement(_link["default"], {
      href: url,
      target: target
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, iconProps, {
      style: {
        fontSize: iconSize
      }
    })));
  }

  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: action
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, iconProps, {
    style: {
      fontSize: iconSize
    }
  })));
};

var Header = function Header(_ref2) {
  var settings = _ref2.settings,
      _ref2$showBar = _ref2.showBar,
      showBar = _ref2$showBar === void 0 ? false : _ref2$showBar,
      _ref2$showSearchbar = _ref2.showSearchbar,
      showSearchbar = _ref2$showSearchbar === void 0 ? false : _ref2$showSearchbar,
      _ref2$iconSize = _ref2.iconSize,
      iconSize = _ref2$iconSize === void 0 ? 24 : _ref2$iconSize,
      isMenuOpen = _ref2.isMenuOpen,
      onMenuClick = _ref2.onMenuClick,
      onSearchClick = _ref2.onSearchClick,
      onMemberClick = _ref2.onMemberClick,
      pages = _ref2.pages;

  var _ref3 = settings || {},
      _ref3$showLogo = _ref3.showLogo,
      showLogo = _ref3$showLogo === void 0 ? true : _ref3$showLogo,
      _ref3$alignment = _ref3.alignment,
      alignment = _ref3$alignment === void 0 ? _constant.ALIGNMENT.CENTER : _ref3$alignment,
      background = _ref3.background,
      color = _ref3.color;

  var isAlignLeft = alignment === _constant.ALIGNMENT.LEFT;
  var authAction = pages.find(function (page) {
    return page.action === _menu.MENU_ACTION_TYPES.AUTH;
  });
  var cartAction = pages.find(function (page) {
    return page.action === _menu.MENU_ACTION_TYPES.CART;
  });
  return /*#__PURE__*/_react["default"].createElement("header", {
    id: "menu-mobile-fixedTop",
    className: styles.root,
    style: {
      gridTemplateColumns: alignment === _constant.ALIGNMENT.CENTER ? '80px 1fr 80px' : '40px 1fr 120px',
      background: background || 'var(--color-2)',
      color: color || 'var(--color-3)',
      fill: color || 'var(--color-3)'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.left
  }, showBar && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: onMenuClick
  }, isMenuOpen ? /*#__PURE__*/_react["default"].createElement(_CloseOutlined["default"], {
    style: {
      fontSize: 20
    }
  }) : /*#__PURE__*/_react["default"].createElement(_MenuOutlined["default"], {
    style: {
      fontSize: 20
    }
  })), showSearchbar && !isAlignLeft && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: onSearchClick
  }, /*#__PURE__*/_react["default"].createElement(_SearchOutlined["default"], {
    style: {
      fontSize: 20
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.center,
    style: {
      justifyContent: isAlignLeft ? 'flex-start' : 'center'
    }
  }, showLogo ? /*#__PURE__*/_react["default"].createElement("a", {
    className: styles.logo,
    href: "/"
  }, /*#__PURE__*/_react["default"].createElement(_Logo["default"], null)) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.right
  }, showSearchbar && isAlignLeft && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: onSearchClick
  }, /*#__PURE__*/_react["default"].createElement(_SearchOutlined["default"], {
    style: {
      fontSize: 20
    }
  })), !!authAction && /*#__PURE__*/_react["default"].createElement(ActionButton, {
    onMemberClick: onMemberClick,
    iconSize: iconSize,
    page: authAction
  }), !!cartAction && /*#__PURE__*/_react["default"].createElement(ActionButton, {
    iconSize: iconSize,
    page: cartAction
  })));
};

var _default = Header;
exports["default"] = _default;